/**
 * 后台预览从作品内容（content_json）取展示用的人物与开场；书架简介由详情响应的 teaser 给出。
 * 草稿内容可能没通过校验，每一层都要容忍缺失和错型。
 */

const asList = (value) => (Array.isArray(value) ? value : [])
const textOf = (value) => (typeof value === 'string' ? value : '')

/** 人物卡：名字、公开简介、头像；玩家自己的角色单独标出。 */
export function castOf(content) {
  return asList(content.characters)
    .filter((person) => person !== null && typeof person === 'object')
    .map((person, index) => {
      const name = textOf(person.name)
      return {
        key: textOf(person.id) || `#${index}`,
        name,
        initial: [...name.trim()][0] ?? '?',
        public_profile: textOf(person.public_profile),
        image: textOf(person.image),
        is_player: person.id === content.player_id,
      }
    })
}

/** 开场正文：schema v2 分段并带说话人，v1 是一整段文字。 */
export function openingLines(content) {
  const opening = content.opening ?? {}
  const segments = asList(opening.segments)
  if (segments.length === 0) return textOf(opening.text) ? [{ key: 0, speaker: '', text: opening.text }] : []
  const names = new Map(castOf(content).map((person) => [person.key, person.name]))
  return segments.map((segment, index) => ({
    key: index,
    speaker: names.get(textOf(segment?.speaker_id)) ?? '',
    text: textOf(segment?.text),
  }))
}
